import styled from 'styled-components';

export const SummaryCard = styled.div`
    display: flex;
    padding: 0.75rem;
    flex-direction: column;
    gap: 0.25rem;
    border-radius: 1.25rem;
    outline: 2px solid var(--Silver-100, #ededed);
    background: var(--Neutral-0, #fff);

    .category {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }
`;

export const SummaryHeader = styled.div`
    display: flex;
    color: var(--Silver-800, #676767);
    align-items: center;
    cursor: pointer;
    gap: 0.25rem;

    .quantity {
        color: var(--Neutral-800, #27272a);
        text-align: right;
        font-size: 1rem;
        font-weight: 600;
        line-height: 1rem; /* 100% */
        margin-left: auto;
    }

    p.title {
        color: var(--Silver-800, #676767);
        font-family: 'Hero New';
        font-size: 0.9375rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1rem;
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
        color: #676767;
    }
`;

export const SummaryContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-left: 0.5rem;
    .row {
        display: flex;
        justify-content: space-between;
    }

    span {
        color: var(--Silver-400, #adadad);
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1rem;
    }
`;

export const DashedLine = styled.div`
    border-top: 0.125rem dashed #ccc;
    border-top: 0.125rem solid transparent;
    background: linear-gradient(to right, #ccc 33%, rgba(255, 255, 255, 0) 0%);
    background-size: 1.875rem 0.125rem;

    margin: 0.4rem 0;
`;

export const SummaryItemStyled = styled.div`
    display: flex;
    justify-content: space-between;
    font-family: Hero New;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1rem;
    text-align: left;
    align-items: center;
    padding-bottom: 0;

    span:first-child {
        flex: 1;
    }

    span:last-child {
        white-space: nowrap;
    }
`;
